import React from 'react';
import moment from 'moment';
import StudentForm from './StudentForm';
import Contact from '~p/EventReg/StudentsForm/Contact';
import { unescapeQuotesInObject } from '~h/text';
import { FormMessage } from '../../../components/FormMessage';

class StudentsForm extends React.Component {
  constructor(props) {
    super(props);

    this.studentsCounter = 0;
    const { lastStudents } = props;

    const students = lastStudents?.map(student => ({
      data: { ...student, id: undefined },
      id: student.id,
      studentRef: React.createRef(),
    }));
    this.state = {
      students: students || [],
      contacts: this.unescapeUserData(window.user?.CONTACTS),
    };
  }

  componentDidMount = () => {
    this.addStudent();
  };

  unescapeUserData = array => {
    return array?.map(item => unescapeQuotesInObject(item)) || array;
  };

  validateForm = () => {
    const { students } = this.state;

    let isValidationPassed = true;
    students.forEach(student => {
      const isFormValid = student.studentRef.current.validateForm();
      isValidationPassed = isValidationPassed && isFormValid;
    });

    return isValidationPassed;
  };

  addStudent = contact => {
    const { students } = this.state;
    if (
      students.find(
        student => student.id != null && student.id === contact.CONTACT_ID,
      )
    )
      return;

    const newStudents = students.slice(0);
    const initialData = {
      name: contact?.FIRST_NAME ?? '',
      lastName: contact?.LAST_NAME ?? '',
      patronymic: contact?.MIDDLE_NAME ?? '',
      company: contact?.COMPANY_NAME ?? '',
      email: contact?.EMAIL ?? '',
      phone: contact?.TELEPHONE ?? '',
      companyPosition: contact?.JOB_TITLE ?? '',
      typeOfActivity: contact?.SPHERE_OF_ACTIVITY ?? '',
      passport: contact?.PASSPORT_NUMBER ?? '',
      citizenship: contact?.CITIZENSHIP ?? '',
      citizenshipCode: contact?.CITIZENSHIP_CODE ?? '',
      passportCreated: contact?.PASSPORT_ISSUE_DATE
        ? moment(contact?.PASSPORT_ISSUE_DATE, 'DD.MM.YYYY').format(
            'DD.MM.YYYY',
          )
        : '',
      birthday: contact?.BIRTH_DATE
        ? moment(contact?.BIRTH_DATE, 'DD.MM.YYYY').format('DD.MM.YYYY')
        : '',
      passportPlaceCreated: contact?.PASSPORT_AUTHORITY ?? '',
      addressOfRegistration: contact?.REGISTRATION_ADDRESS ?? '',
    };

    const student = {
      data: initialData,
      // eslint-disable-next-line
      id: contact?.CONTACT_ID ?? this.studentsCounter++,
      studentRef: React.createRef(),
    };
    newStudents.push(student);
    this.setState({ students: newStudents }, () => {
      this.getData();
    });
  };

  onRemoveStudentClick = index => {
    if (this.state.students.length > 1) {
      const newStudents = this.state.students.slice(0);
      newStudents.splice(index, 1);
      this.setState({ students: newStudents });
    }
  };

  onStudentFormChange = (studentData, index) => {
    const newStudents = this.state.students.slice(0);
    newStudents[index].data = studentData;
    this.setState({ students: newStudents });
  };

  getData = () => {
    const { students } = this.state;
    return students?.map(student => ({
      ...student.data,
      id: student.id,
    }));
  };

  checkStudentPhone = () => {
    const { students } = this.state;
    let isDuplicate;

    const studentsPhones = students.map(el => el.data.phone);

    if (studentsPhones[0] !== '') {
      isDuplicate = studentsPhones.some(
        (el, index) => studentsPhones.indexOf(el) !== index,
      );
    }

    if (this.props.setPhoneCorrect) {
      if (isDuplicate) {
        this.props.setPhoneCorrect(false);
      } else {
        this.props.setPhoneCorrect(true);
      }
    }
  };

  render() {
    const { students } = this.state;
    const { companyRegistration } = this.props;
    if (students) this.checkStudentPhone();

    return (
      <React.Fragment>
        {students.map((student, index, array) => (
          <React.Fragment key={`key-student-${student.id}`}>
            <h4 className="heading heading--2 heading--fixed">
              Участник {index + 1}
              {array.length <= 1 || (
                <button
                  className="btn btn--outline"
                  type="button"
                  onClick={() => this.onRemoveStudentClick(index)}
                >
                  Удалить участника
                </button>
              )}
            </h4>
            <StudentForm
              ref={student.studentRef}
              data={student.data}
              companyRegistration={companyRegistration}
              onChange={value => this.onStudentFormChange(value, index)}
              eventTypes={this.props.eventTypes}
              showAlert={this.props.showAlert}
              removeSelection={this.props.removeSelection}
              isPhoneCorrect={this.props.isPhoneCorrect}
            />
          </React.Fragment>
        ))}
        {this.state.contacts?.length ? (
          <div className="members members--wrap">
            {this.state.contacts.map(contact => (
              <Contact
                key={`key-contact-${contact.CONTACT_ID}`}
                contact={contact}
                onClick={() => this.addStudent(contact)}
              />
            ))}
            <button
              className="member member--new"
              type="button"
              onClick={this.addStudent}
            >
              <div className="member__img" />
              <div className="member__inner">
                <p className="member__name">Новый участник</p>
              </div>
            </button>
          </div>
        ) : (
          <button
            className="btn btn--outline"
            type="button"
            onClick={this.addStudent}
          >
            + Добавить участника
          </button>
        )}
        {!this.props.isPhoneCorrect ? (
          <>
            <div className="separate" />
            <FormMessage extraClass="error">
              <p className="form-message__p">
                Укажите уникальный номер для каждого ученика
              </p>
            </FormMessage>
          </>
        ) : null}
        <div className="separate" />
      </React.Fragment>
    );
  }
}

export default StudentsForm;
